import React, { useRef, useEffect } from "react";
import { Banner3 } from "./Banner3";


export const GridBanel1= ({

    banners = [
        {
            id: "1",
            image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/image-banner.jpg?v=1720610740",
            href: "#",
            title: "",
            describe: "Nước ép tươi làm từ khoai tây",
            action: { title: "Xem thêm", href: "#" },
          }
   
       
    ]
}) => {
   

    return (
        <div className="w-full flex justify-center items-center mt-4 overflow-hidden  px-4">
            <div className="no-scrollbar overflow-x-auto w-full ">
                <div
                  
                    className={`grid grid-cols-1 gap-4  w-full xl:w-[--page-width] m-auto`}
                >
                    {banners?.map((b,index) => (
                        <Banner3  key={index}  b={b} />
                    ))}
                </div>
            </div>
        </div>
    );
};
